<template>
	<div>
		<vue-dropzone
			class="income"
			ref="myVueDropzone"
			id="dropzone"
			:options="dropzoneOptions"
            @vdropzone-success="uploadSuccess"
            @vdropzone-sending="sendingFiles"
            @vdropzone-error="uploadError" />
	</div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

	export default {
		props: [
			'uri',
			'parameters'
		],
		data: () => ({
            dropzoneOptions: {}
		}),
		computed: {
			...mapGetters([
				'getToken'
			]),
		},
		components: {
			vueDropzone: vue2Dropzone
		},
		methods: {
            uploadError (data) {
                if(data.xhr !== null && (data.xhr.status === 401 || data.xhr.status === 403)) {
                    this.$store.commit('setToken', null)
                    return;
                }

                if (typeof data.xhr == 'undefined') {
                    this.$swal(this.$t('general.unknown-error.label'), [], 'error');
                    return;
                }
                let response = JSON.parse(data.xhr.responseText);
                this.$swal(response.message, [], 'error');
            },
            uploadSuccess (file, response) {
                this.uploadedFile = response;
                this.$emit('success');
            },
            sendingFiles (file, xhr, formData) {
            	if (this.parameters) {
            		for (var i in this.parameters) {
                		formData.append(i, this.parameters[i]);
            		}
            	}
            },
		},
		created() {
			this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/' + String(this.uri).replace(/^\//, ''),
                thumbnailWidth: 150,
                maxFilesize: 10,
                paramName: 'file',
				headers: {
					'Authorization': 'Bearer ' + this.getToken
				},
                autoProcessQueue: true,
                dictDefaultMessage: '',
                uploadMultiple: false,
            },
            this.dropzoneOptions.dictDefaultMessage = this.$t('label.upload.placeholder');
		}
	}
</script>
